import moment from "moment";
import { useState } from "react";
import {
  ChipField,
  Datagrid,
  DateField,
  FunctionField,
  ReferenceArrayField,
  ReferenceArrayInput,
  ReferenceField,
  ReferenceInput,
  SelectArrayInput,
  SelectInput,
  SingleFieldList,
  TextField,
  useListContext,
  usePermissions,
  AutocompleteInput,} from "react-admin";
import { ReportList } from "../../components";
import { BetweenDatesInput } from "../../components/BetweenDatesInput";
import { PartiallyHiddenCpfField } from "../../components/Fields";
import ListPagination from "../../components/ListPagination";
import Permission from "../../components/Permission";
import { PERMISSIONS } from "../../constants";
import { getChainId } from "../../lib";
import { formatPoints, filterToQuery} from "../../utils";

const ApprovedTransactions = () => {
  return (
    <Datagrid bulkActionButtons={false} style={{ marginTop: 40 }}>
      <ReferenceField
        source="authorizedBy"
        reference="employees"
        textAlign="center"
        label="Aprovado por"
        sortable={false}
        link={false}
      >
        <TextField source="name" />
      </ReferenceField>
      <PartiallyHiddenCpfField
        source="customerCpf"
        textAlign="center"
        label="CPF do Cliente"
      />
      <FunctionField
        label="Quantidade de pontos"
        textAlign="center"
        render={record => formatPoints(record.value)}
      />
      <DateField source="createdAt" label="Data da Aprovação" showTime locales="pt-BR" />
    </Datagrid>
  );
};

const FilterTablePrint = () => {
  const { filterValues } = useListContext();
  return (
    <Datagrid bulkActionButtons={false} data={[{ ...filterValues, generatedReportAt: moment().toISOString() }]} total={1}>
      <DateField source="from" textAlign="center" label="De" sortable={false} locales="pt-BR" />
      <DateField source="to" textAlign="center" label="Até" sortable={false} locales="pt-BR" />
      <DateField source="generatedReportAt" textAlign="center" label="Gerado às" showTime sortable={false} locales="pt-BR" />
      <ReferenceArrayField source="employeeIds" emptyText="Todos" reference="employees" label="Funcionários" sortable={false}>
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      <ReferenceField source="chainId" reference="chains" emptyText="Todas" textAlign="center" label="Rede" sortable={false} >
        <TextField source="name" />
      </ReferenceField>
    </Datagrid>
  );
}

const ReportApprovedTransactions = (props) => {
  const [selectedChain, setSelectedChain] = useState();
  const { permissions } = usePermissions();

  const listFilters = [
    <BetweenDatesInput alwaysOn />,
    <ReferenceArrayInput
      source="employeeIds"
      reference="employees"
      perPage={null}
      sort={{ field: "name", order: "ASC" }}
      filter={{ chainId: selectedChain ? selectedChain : getChainId() }}
      style={{ minWidth: 160 }}
      alwaysOn
    >
      <SelectArrayInput label="Funcionários" emptyText="Todos" optionText="name" />
    </ReferenceArrayInput>,
  ];

  if (permissions && permissions.includes(PERMISSIONS.ADMIN)) {
    listFilters.push(
      <ReferenceInput
        source="chainId"
        reference="chains"
        perPage={null}
        sort={{ field: "name", order: "ASC" }}
        onChange={({ target }) => setSelectedChain(target.value)}
        alwaysOn
      >
        <AutocompleteInput
          filterToQuery={filterToQuery}
          label="Rede"
          optionText="name"
        />
      </ReferenceInput>
    );
  }

  return (
    <Permission permission={PERMISSIONS.APPROVED_TRANSACTIONS_REPORT}>
      <ReportList periodRequired
        {...props}
        basePath="report-approved-transactions"
        title="Transações Aprovadas"
        resource="chains/chainId/reports/approved-transactions"
        filters={listFilters}
        sort={{ field: 'createdAt', order: 'DESC' }}
        perPage={25}
        pagination={<ListPagination />}
        filterDefaultValues={{
          chainId: getChainId(),
          from: moment().startOf('day').subtract(1, "month").toISOString(),
          to: moment().endOf('day').toISOString()
        }}
        bulkActionButtons={false}
        exporter={false}
        titleOnPrint="Transações Aprovadas"
        filterTablePrint={<FilterTablePrint />}
        landscape
      >
        <ApprovedTransactions />
      </ReportList>
    </Permission >
  );
};

export default ReportApprovedTransactions;